import { render, staticRenderFns } from "./company.vue?vue&type=template&id=5ca8e194&scoped=true&lang=pug&"
var script = {}
import style0 from "./company.vue?vue&type=style&index=0&id=5ca8e194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8e194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca8e194')) {
      api.createRecord('5ca8e194', component.options)
    } else {
      api.reload('5ca8e194', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=5ca8e194&scoped=true&lang=pug&", function () {
      api.rerender('5ca8e194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/company.vue"
export default component.exports